var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2AtticRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM22 29h32a4 4 0 014 4v3h-7v-3h-3v3H28v-3h-3v3h-7v-3.06A4 4 0 0122 29zm29 10h5v17h-5V39zM28 56h20V39H28v17zm7-14h6v3h-6v-3zm-15-3h5v17h-5V39z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Attic_room.00774410.svg";
export { SvgE2AtticRoom as ReactComponent };